module.exports = __webpack_public_path__ + "static/media/12. Speaker Khadijah Iskandar.8089382a.png";